import React from "react";

const UserContext = React.createContext({});

export { UserContext };
